<div class="modal-window">
    <div class="title" matDialogTitle>IMPORT SUMMARY</div>
    <mat-dialog-content>
        <div class="flex-column" style="align-items: center">
            <!-- Asset Total Warning -->
            <div class="flex justify-content-center center" style="margin-top: 20px">
                <mat-icon class="warning" svgIcon="error"></mat-icon>
                <div class="flex-column" style="margin-left: 10px">
                    <span>Total # of Assets Identified in file: {{totalAssets}}</span>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <div class="flex justify-flex-end gap-20 buttons" style="margin: 50px;">
        <button mat-raised-button matDialogClose>Cancel Import</button>
        <button mat-raised-button color=primary (click)="dialogRef.close(true)">Continue With Import</button>
    </div>
</div>
